/**
 *
 * FlexIcon
 *
 */

import React from 'react';
import lodash from 'lodash';

import styles from './styles.module.css';

function FlexIcon(props) {
  const {
    style,
    fontawesome,
    name,
    gutter = 5,
    guttered,
    rightGutter,
    bottomGutter,
    leftGutter,
    topGutter,
    src,
    size = 'small',
  } = props;

  let elemStyle = style ? lodash.cloneDeep(style) : {};
  if (rightGutter || guttered) {
    elemStyle.marginRight = `${gutter}px`;
  }

  if (bottomGutter || guttered) {
    elemStyle.marginBottom = `${gutter}px`;
  }

  if (leftGutter || guttered) {
    elemStyle.marginLeft = `${gutter}px`;
  }

  if (topGutter || guttered) {
    elemStyle.marginTop = `${gutter}px`;
  }

  let iconElem;
  if (src) {
    iconElem = (
      <img
        onClick={props.onClick}
        style={elemStyle}
        src={src}
        className={`${styles.imageIcon} ${styles[size]} ${props.className}`}
      />
    );
  } else if (fontawesome) {
    iconElem = (
      <div
        onClick={props.onClick}
        style={elemStyle}
        className={`${styles.fontAwesomeIcon} fa fa-${name} ${props.className}`}
      />
    );
  } else {
    iconElem = (
      <div
        onClick={props.onClick}
        style={elemStyle}
        className={`${styles.materialIcon} material-icons ${props.className}`}
      >
        {name}
      </div>
    );
  }

  return iconElem;
}

FlexIcon.propTypes = {};

export default FlexIcon;
